module.exports = require('./globals.json');



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-types/~/babel-traverse/~/globals/index.js
 ** module id = 254
 ** module chunks = 0
 **/